export default function({ commit, dispatch }, id) {
    commit('setCurrentProvider', id)
}
